define('page/case', [
    'ISwiper',
    'Vue',
    'utils/service',
    'utils/tools',
    'component/pagination/index'
], function (ISwiper, Vue, service, tools, vuePagination) {
    new ISwiper.default({
        wrapper: '#caseSwiper',
        duration: 0,
        btn: {
            visible: false,
            transition: false
        },
        dotAction: 'click',
        mode: 'fade', 
    })

    new Vue({
        el: '#app', 
        data: function () {
            return {
                xwCase: {
                    list: [],
                    pageIndex: 1,
                    pageSize: 15,
                    count: 0
                },
                label: {
                    list: [],
                    tagId: 0
                }
            }
        },
        components: {
            'vue-pagination': vuePagination
        },
        methods: {
            getLabelList: function () {
                var label = this.label
                var pendData = service.getCaseLabelList()

                pendData.then(function (res) {
                    if (res && Array.isArray(res)) {
                        label.list = res.map(function (item) {
                            return tools.toVaildData(['id', 'tagname', 'ActiveIconUrl', 'DefaultIconUrl'], item)
                        })
                    }
                })
            },
            getCaselList: function () {
                var vmCase = this.xwCase
                var pendData = service.getCaseList({
                    pageIndex: vmCase.pageIndex,
                    pageSize: vmCase.pageSize,
                    tagId: this.label.tagId
                })

                pendData.then(function (res) {
                    if (res) {
                        vmCase.count = res.count
                        vmCase.list = res.list.map(function (item) {
                            return tools.toVaildData(['CaseName', 'CoverPath', 'QrcodePath'], item)
                        })
                    }
                })
            },
            updateCaseList: function (i) {
                var vmCase = this.xwCase
                vmCase.pageIndex = i
                this.getCaselList()
            },
            selectLabel: function (tagId) {
                this.label.tagId = tagId
                tools.resetPageData(this, 'xwCase.list', 'xwCase.pageIndex')
                this.getCaselList()
            }
        },
        beforeMount: function () {
            this.getCaselList()
            this.getLabelList()
        }
    })
});
